import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Message } from 'primeng/components/common/api';
import { RegistrationService } from '../../services/registration.service';
import { NgxSpinnerService } from 'ngx-spinner';
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
  FormArray,
  FormControlDirective,
  FormControlName
} from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-academic-information',
  templateUrl: './academic-information.component.html',
  styleUrls: ['./academic-information.component.scss']
})
export class AcademicInformationComponent implements OnInit {
  msgs: Message[] = [];
  msgserror: Message[] = [];
  msgMarksEntry: Message[] = [];
  msgInstDetails: Message[] = [];
  alertMsg: Message[] = [];
  activeIndex = 1;

  cars: any[];
  cols: any[];

  marksEntryDialogDisplay: boolean;
  instDetailsDialogDisplay: boolean;

  academicForm: FormGroup;

  dataList: any;
  isOtherInst: boolean = true;
  isOtherState: boolean = true;
  isOtherCity: boolean = true;
  otherOption: boolean = false;
  isPrevUniv: boolean = false;
  isPrevUnivSingle: boolean = false;
  isOtherCourse: boolean = true;
  isOtherPrevCollege: boolean = true;
  countryId: any;
  stateId: any;
  data: any;
  newRow: any;
  token: any;
  isCuRegCourseTypePrevColg: boolean = false;
  // isCuRegCourseTypePrevColgSingle: boolean = false;
  isError: boolean = false;
  showclose = false;
  preRegBox: boolean = false;
  textBoxforCourse: boolean = false;
  failComSelect: boolean = false;

  public boardList = [];
  public englishSubjects = [];
  public nonEnglishSubjects = [];

  public englishSubjectsHidden = [];
  public nonEnglishSubjectsHidden = [];

  public lastInstituteList = [];
  public allcountrylist = [];
  public stateList = [];
  public cityList = [];
  public instMediumList = [];
  public passingYearList = [];
  public prvcourseTypeList = [];
  public prevCollegeList = [];
  public prevstreamList = [];
  public patchList = [];
  public gradeList = [];
  public levelList = [];
  public passfailList = [];
  public statusList = [];
  public genericList = [];
  totalMarks: any;
  theoryFullMarks: any;
  practicalFullMarks: any;
  theoryPassMarks: any;
  practicalPassMarks: any;
  paperType: any;
  type: boolean = false;
  disablePracticalMarks: boolean = false;
  disablePassInst: boolean = true;
  passfail: any;
  disablesubmit = false;
  disableBoard: boolean = false;
  crsselct: any;
  resdata: any;
  // @ViewChild('fullMarks') inputs : ElementRef;
  // @ViewChild('obtainmarks') inputmarks : ElementRef;
  doneButton: boolean = true;
  mandatoryfieldMsg: Message[] = [];
  boardid: any;
  boarrollnoforotherboard = false;
  labelName: any = 'Roll No';
  alphaNumeric = "^[a-zA-Z0-9]*$";
  onlyNumeric = "^[0-9]*$";
  // numberRegEx = '^[0-9-]*$';
  totalMarksTableSize: any = 5;

  constructor(
    private registrationService: RegistrationService,
    private fb: FormBuilder,
    private router: Router,
    private spinner: NgxSpinnerService
  ) {
    // custom focus on form input
    // const originFormControlNgOnChanges = FormControlDirective.prototype.ngOnChanges;
    // FormControlDirective.prototype.ngOnChanges = function () {
    // 	this.form.nativeElement = this.valueAccessor._elementRef.nativeElement;
    // 	return originFormControlNgOnChanges.apply(this, arguments);
    // };

    // const originFormControlNameNgOnChanges = FormControlName.prototype.ngOnChanges;
    // FormControlName.prototype.ngOnChanges = function () {
    // 	const result = originFormControlNameNgOnChanges.apply(this, arguments);
    // 	this.control.nativeElement = this.valueAccessor._elementRef.nativeElement;
    // 	return result;
    // };
  }

  ngOnInit() {
    this.spinner.show();
    this.alertMsg = [];
    this.msgs = [];
    this.msgs.push({ severity: 'info', summary: 'Please Note :' });
    this.msgs.push({
      severity: 'info',
      detail:
        '1. Candidates with “Pass Certificate Awarded” as their Class XII Board result are only eligible to apply.'
    });
    this.msgs.push({
      severity: 'info',
      summary:
        '2. Fail / Compartmental students are not allowed to apply as per Calcutta University Norms.'
    });
    this.msgs.push({
      severity: 'info',
      detail:
        '3. Fill-up your marks as per your class XII Board marksheet in the marks Entry option.'
    });
    this.msgs.push({
      severity: 'info',
      detail:
        '4. In case your Board has not issued the Original Marksheet yet, you can proceed with your application by entering the marks as given in your Digital Marksheet.'
    });
    this.msgs.push({
      severity: 'info',
      detail:
        '5. It is mandatory for students to provide the Original copy of the Class XII Board Marksheet at the time of document verification or when asked by the College, if selected.'
    });
    this.msgs.push({
      severity: 'info',
      detail:
        '6. Applicants whose board is not listed in the drop-down, need to get an Equivalency Certificate from Equivalency Department of Calcutta University, College street campus.'
    });
    // this.msgs.push({
    // 	severity: 'info',
    // 	detail: '4. After entering marks details, enter institute details.'
    // });
    this.msgs.push({
      severity: 'info',
      detail:
        '7. Once Board / Marks & Institute details are filled up, please click on Submit button to save and continue for course selection.'
    });
    this.msgs.push({
      severity: 'info',
      detail:
        '8. <strong><font color="red">Red dot</font></strong> indicates mandatory field.'
    });

    this.msgMarksEntry = [];
    this.msgMarksEntry.push({ severity: 'info', summary: 'Please Note :' });
    this.msgMarksEntry.push({
      severity: 'info',
      detail: '<strong>i. Please enter all Subjects Marks as per Class XII Board MarkSheet</strong>'
    });
    this.msgMarksEntry.push({
      severity: 'info',
      detail:
        '<strong>For Example : If you have Five Subjects then Marks of Five Subjects have to be Entered.</strong>'
    });
    this.msgMarksEntry.push({
      severity: 'info',
      detail:
        '<strong>ii. Applicants with theory and practical division of marks, need to add the marks before entering but select the subject result status as per the marksheet only, as applicable.</strong>'
    });
    this.msgMarksEntry.push({
      severity: 'info',
      detail:
        //'ii.  Applicants having Class XII Board result as "Pass" but having failed subject(s) are required to put in their Pass subject marks only.'
        'iii. Marks entered with "Subject Result Status" as "Fail / Fail in Theory / Fail in Practical" will not be considered for calculation of BO4.'
    });
    this.msgMarksEntry.push({
      severity: 'info',
      detail: 'iv. English Marks must be Entered.'
    });
    // this.msgMarksEntry.push({
    // 	severity: 'info',
    // 	detail:
    // 		'iv. In case of WB Board, Subjects having both Theory and Practical, marks is to be entered separately in respective columns. '
    // });
    this.msgMarksEntry.push({
      severity: 'info',
      detail:
        'v. For students, who have studied more than 1 (One) English subject with 100 marks each, they can select “Additional English” in row no. 2 & give their 2nd English subject marks.'
    });
    this.msgMarksEntry.push({
      severity: 'info',
      detail:
        'vi. Please do not Enter SUPW / SUPW & Community Services Marks / Grade.'
    });

    this.msgMarksEntry.push({
      severity: 'info',
      detail:
        'vii. In case if you cannot find your subject in the dropdown, please mail us your scanned copy of marksheet at admission@thebges.edu.in'
    });

    // this.msgMarksEntry.push({
    // 	severity: 'info',
    // 	detail:
    // 		'vi. Securing pass marks in Mathematics / Business Mathematics / Statistics is mandatory for BBA. Please input the same particularly for BBA Application.'
    // });


    this.autoLogin();
    this.msgInstDetails = [];
    this.msgInstDetails.push({ severity: 'info', summary: 'Please Note :' });
    this.msgInstDetails.push({
      severity: 'info',
      detail:
        'i.  Please select your Class 12 school name under the “Select Institute” option in serial no. b(i). In case your school’s name is not enlisted in the dropdown list, select “Other Institute” from the list and enter the name of your school in serial no. b(ii).'
    });

    this.msgInstDetails.push({
      severity: 'info',
      detail:
        'ii.  Sr. No. f to j is applicable for students who have cleared class XII board exam in or before year 2025.'
    });
    // this.msgInstDetails.push({
    // 	severity: 'info',
    // 	detail:
    // 		'ii. Sr. No. 22 And 23 is applicable only for those students who are pre-registered under Calcutta University.'
    // });

    //this.msgInstDetails.push({
     // severity: 'info',
      //detail:
      //  'iii. Candidates who are already registered with Calcutta University under Annual System (1+1+1 Regulations), are not eligible to apply for any of the courses.'
    //});

    //this.msgInstDetails.push({
      //severity: 'info',
      //detail:
       // 'iv. For students already registered with the University of Calcutta previously, if applying for a different course then proceed with your application and if applying for the same course, confirm eligibility by visiting Admission Department, 4th Floor, College Campus, 10am-1pm (Mon-Fri).'
   // });
    this.msgInstDetails.push({
      severity: 'info',
      detail:
        'iii. <strong><font color="red">Red dot</font></strong> indicates mandatory field.'
    });

    if (localStorage.getItem('meritlisted') === "yes") {
      this.disablesubmit = true;
    }

    this.cars = [
      {
        vin: 'ee8a89d8',
        brand: 'Fiat',
        year: 1987,
        color: 'Maroon'
      }
    ];

    this.cols = [
      { field: 'vin', header: 'Serial No' },
      { field: 'year', header: 'Board/University' },
      { field: 'brand', header: 'Subjectwise Marks' },
      { field: 'color', header: 'Institute Details' }
    ];

    this.passfailList = [
      {
        'id': 'Pass',
        'name': 'Pass'
      }, {
        'id': 'Fail',
        'name': 'Fail'
      }, {
        'id': 'Compartmental',
        'name': 'Compartmental'
      }
    ];

    this.statusList = [
      {
        'id': 'Pass',
        'name': 'Pass'
      },
      {
        'id': 'Fail in Theory',
        'name': 'Fail in Theory'
      },
      {
        'id': 'Fail in Practical',
        'name': 'Fail in Practical'
      },
      {
        'id': 'Fail',
        'name': 'Fail'
      }
    ]
    this.genericList = [
      { id: 'No', name: 'No' },
      { id: 'Yes', name: 'Yes' }
    ];

    this.passfail = 0;
    this.registrationService
      .getAcademicList(localStorage.getItem('authToken'))
      .then(commonList => {
        // console.log(commonList);
        this.dataList = commonList;
        // console.log(this.dataList.yearOfPassing)
        this.boardList = commonList.boardlist;
        // this.englishSubjects = commonList.EngList;
        // this.nonEnglishSubjects = commonList.allpaperlist;
        this.lastInstituteList = this.dataList.LastInstListforXI;
        this.allcountrylist = this.dataList.allcountrylist;
        this.instMediumList = this.dataList.instMediumList;
        this.passingYearList = this.dataList.yearOfPassing;
        this.prvcourseTypeList = this.dataList.prvcourseTypeList;
        this.prevCollegeList = this.dataList.PrvInstListforGRD;
        this.gradeList = this.dataList.gradelist;
        this.levelList = this.dataList.levellist
        this.spinner.hide();
      }, error => {
        alert('Something went wrong. Please try again')
        this.spinner.hide();
      });
    this.academicForm = this.fb.group({
      boardResultStatus: [null, Validators.required],
      boardId: [null, Validators.required],
      // regno: [null, Validators.required],
      lastschoolId: [null, Validators.required],
      //schoolCountryId: [null, Validators.required],
      //stateId: [null, Validators.required],
      //schoolcityId: [null, Validators.required],
      mediumofInstruction: ['1', Validators.required],
      yearofPassing: [null, Validators.required],
      prevadmitted: ['No'],
      prevcrshdrid: [null],
      previnstid: [null],
      sciencebg: [null, Validators.required],
      lastschoolName: [null],
      // otherSchoolState: [null],
      //otherSchoolCity: [null],
      // prevregno: [null],
      //new field
      prevcrshdrother: [null],
      previnstother: [null],
      // prevuniexam: [null],
      //new field
      id: [null],
      parent_id: [null],
      degreeCourseId: ['2'],
      degreeId: ['2'],
      subjectDetailInfo: this.fb.array([]),

      regno: new FormControl('', [Validators.required]),
      // boardroll2: new FormControl('',[Validators.required]),
      schoolno: new FormControl('',[Validators.pattern('[0-9]{5}')]),
      centerno: new FormControl('',[Validators.pattern('^[0-9]*$')]),
      admintcardid: new FormControl('',[Validators.pattern('^[0-9A-Za-z]*$')]),
      registrationno: new FormControl('',[Validators.pattern('[0-9]{10}')]),
      indexno1: new FormControl('',[Validators.pattern('[0-9]{7}')]),
      indexno2: new FormControl('',[Validators.pattern('[0-9]{3}')]),
      prevregno: new FormControl(null,[Validators.pattern('[0-9-]{16}')]),
    });
    if (localStorage.getItem('step') == '') {
      this.showclose = true;
    }
  }

  patchForm() {
    this.token = JSON.parse(localStorage.getItem('userDetails'));
    this.token = '';
    this.token = JSON.parse(localStorage.getItem('userDetails'));
    //console.log(this.token.academicDetailInfo[0].subjectDetailInfo[0].fullMarks);
    //newly added condition
    //this.passfail = 1;
    // console.log(this.token);
    // this.academicForm.controls['prevadmitted'].setValue(this.token.academicDetailInfo[0].prevadmitted);
    // console.log(this.token.academicDetailInfo[0].prevadmitted);
    // console.log(this.academicForm.controls['prevadmitted']);

    if (this.token.academicDetailInfo[0] != undefined) {
      if (this.token.academicDetailInfo[0].boardResultStatus != 'Pass') {
        this.disablePassInst = true;
      }
      else {
        this.disablePassInst = false;
      }
      if (this.dataList.courseSelection == 'yes') {
        this.academicForm.get('boardResultStatus').disable();
        this.failComSelect = true;
      }
      this.academicForm.patchValue(this.token.academicDetailInfo[0]);
      this.getStateCity(
        this.token.academicDetailInfo[0].schoolCountryId,
        this.token.academicDetailInfo[0].stateId,
        this.token.academicDetailInfo[0].cityId
      )
      if (this.token.academicDetailInfo[0].subjectDetailInfo[0].fullMarks != null) {
        this.paperType = 'Theory Practical';
        this.setMarks();
      }
      else if (this.token.academicDetailInfo[0].subjectDetailInfo[0].gradeid != null) {
        this.paperType = 'Grade Level';
        this.setGrade();
      }
    }
    this.enableOtherInst();
    this.enablePrevuniv();
    this.enableCuRegCoursTypPrevClg();

  }
  setMarks() {
    this.spinner.show();
    let token = localStorage.getItem('authToken');
    let id = this.token.academicDetailInfo[0].boardId;
    this.registrationService.getPaperList(token, id).then(res => {
      // console.log(res);
      this.englishSubjects = res.EngList;
      this.nonEnglishSubjects = res.allpaperlist;
      this.englishSubjectsHidden = res.EngList;
      this.nonEnglishSubjectsHidden = res.allpaperlist;
      this.spinner.hide();
    }, err => {
      ///alert("Something went wrong, Please try again.")
      this.spinner.hide();
    });
    let control = <FormArray>this.academicForm.controls.subjectDetailInfo;
    const controlArray = <FormArray>this.academicForm.get('subjectDetailInfo');
    this.token.academicDetailInfo[0].subjectDetailInfo.forEach((x, index) => {
      control.push(
        this.fb.group({
          paperName: x.paperName,
          fullMarks: x.fullMarks,
          obtainmarks: x.obtainmarks,
          id: x.id,
          parent_id: x.parent_id,
          theoryFullMarks: x.theoryFullMarks,
          practicalFullMarks: x.practicalFullMarks,
          theoryPassMarks: x.theoryPassMarks,
          practicalPassMarks: x.practicalPassMarks,
          theoryMarksobtained: x.theoryMarksobtained,
          practicalMarksobtained: x.practicalMarksobtained,
          status: x.status,
        })
      );
      if (x.practicalMarksobtained == null) {
        controlArray.controls[index].get('practicalMarksobtained').disable();
      }
    });
  }

  setGrade() {
    let token = localStorage.getItem('authToken');
    let id = this.token.academicDetailInfo[0].boardId;
    this.registrationService.getPaperList(token, id).then(res => {
      this.englishSubjects = res.EngList;
      this.nonEnglishSubjects = res.allpaperlist;
    });
    let control = <FormArray>this.academicForm.controls.subjectDetailInfo;
    this.token.academicDetailInfo[0].subjectDetailInfo.forEach(x => {
      control.push(
        this.fb.group({
          id: x.id,
          parent_id: x.parent_id,
          paperName: x.paperName,
          gradeid: x.gradeid,
          levelid: x.levelid,
          status: x.status
        })
      );
    });
  }


  showMarksEntryDialog() {
    // console.log(this.failComSelect,this.academicForm.value.boardResultStatus);
    if (this.academicForm.value.boardResultStatus != 'Pass' && this.failComSelect == false) {
      // this.disablePassInst = true;
      return false;
    }
    if (this.academicForm.value.boardId == null) {
      this.alertMsg = [];
      this.alertMsg.push({ severity: 'error', summary: 'Error Message', detail: 'Please select Board' });
      return false;
    }
    const arr = <FormArray>this.academicForm.controls['subjectDetailInfo'];
    //arr.controls = [];
    this.marksEntryDialogDisplay = true;
    if (arr.length == 0) {
      for (let i = 1; i <= 5; i++) {
        this.addMarks();
      }
    }
  }

  donemarksEntry() {
    this.mandatoryfieldMsg = [];
    // console.log(this.academicForm.value.subjectDetailInfo);
    const control = this.academicForm.value.subjectDetailInfo;
    const controlArray = <FormArray>this.academicForm.get('subjectDetailInfo');
    if (this.paperType === 'Theory Practical') {
      for (let i = 0; i < control.length; i++) {
        if (control[i].paperName == 0) {
          this.msgserror = [];
          this.msgserror.push({
            severity: 'error',
            summary: 'Please select subject at row no.' + (1 + i) + ' or click on the red cross to remove the row.'
          });
          return false;
        }
        if (control[i].status == 0) {
          this.msgserror = [];
          this.msgserror.push({
            severity: 'error',
            summary: 'Please select status at row no.' + (1 + i)
          });
          return false;
        }
        if (control[i].theoryFullMarks > 0 && control[i].theoryMarksobtained == '') {
          this.msgserror = [];
          this.msgserror.push({
            severity: 'error',
            summary: 'Please enter Marks Obtained at row no.' + (1 + i)
          });
          return false;
        }
        // if (control[i].practicalFullMarks > 0 && control[i].practicalMarksobtained == '') {
        // 	this.msgserror = [];
        // 	this.msgserror.push({
        // 		severity: 'error',
        // 		summary: 'Please enter Practical Marks Obtained at row no.' + (1 + i)
        // 	});
        // 	return false;
        // }

        // if (Number(control[i].practicalMarksobtained) > Number(control[i].practicalFullMarks)) {
        // 	controlArray.controls[i].get('practicalMarksobtained').setValue('');
        // 	this.msgserror = [];
        // 	this.msgserror.push({
        // 		severity: 'error',
        // 		summary: 'Please enter Valid Practical Marks Obtained at row no.' + (1 + i)
        // 	});
        // 	return false;
        // }

        if (Number(control[i].theoryMarksobtained) > Number(control[i].fullMarks)) {
          controlArray.controls[i].get('theoryMarksobtained').setValue('');
          this.msgserror = [];
          this.msgserror.push({
            severity: 'error',
            summary: 'Please enter Valid Marks Obtained at row no.' + (1 + i)
          });
          return false;
        }
      }
    }
    if (this.paperType === 'Grade Level') {
      for (let i = 0; i < control.length; i++) {
        if (control[i].paperName == 0) {
          this.msgserror = [];
          this.msgserror.push({
            severity: 'error',
            summary: 'Please select subject at row no.' + (1 + i)
          });
          return false;
        }

        if (control[i].gradeid == 0) {
          this.msgserror = [];
          this.msgserror.push({
            severity: 'error',
            summary: 'Please select Grade at row no.' + (1 + i)
          });
          return false;
        }
        if (control[i].status == 0) {
          this.msgserror = [];
          this.msgserror.push({
            severity: 'error',
            summary: 'Please select status at row no.' + (1 + i)
          });
          return false;
        }
        // if (control[i].levelid == 0) {
        // 	this.msgserror = [];
        // 	this.msgserror.push({
        // 		severity: 'error',
        // 		summary: 'Please select Level at row no.' + (1 + i)
        // 	});
        // 	return false;
        // }
      }
    }
    //console.log(this.academicForm.value.subjectDetailInfo);
    
    this.marksEntryDialogDisplay = false;
  }

  checkRepeat(i, e) {
    const p = e.target.value;
    let marksdata = [];
    marksdata = this.academicForm.value.subjectDetailInfo;
    for (let n = 0; n < marksdata.length; n++) {
      if (n !== i) {
        if (marksdata[n].paperName == p) {
          e.target.value = 0;
          return false;
        }
      }
    }
  }

  addMarks() {
    const control = <FormArray>this.academicForm.controls['subjectDetailInfo'];
    let newMarksGroup: FormGroup = this.initItems();
    control.push(newMarksGroup);
    this.totalMarksTableSize = control.length;
  }
  initItems(): FormGroup {
    if (this.paperType === 'Theory Practical') {
      return this.fb.group({
        paperName: ['0', Validators.required],
        fullMarks: ['', Validators.required],
        obtainmarks: [null, Validators.required],
        id: [''],
        parent_id: ['0'],
        theoryFullMarks: [],
        practicalFullMarks: [],
        theoryPassMarks: [],
        practicalPassMarks: [],
        theoryMarksobtained: [''],
        practicalMarksobtained: [''],
        status: ['0', Validators.required]
      });
    }
    else if (this.paperType === 'Grade Level') {
      return this.fb.group({
        id: [''],
        parent_id: ['0'],
        paperName: ['0', Validators.required],
        gradeid: ['0', Validators.required],
        levelid: ['0', Validators.required],
        status: ['0', Validators.required]
      });
    }

    //this.englishSubjects[0].paperName.split("~!~")[4]
  }

  removeMarks(index, id) {
    const control = <FormArray>this.academicForm.controls['subjectDetailInfo'];
    control.removeAt(index);
    if (id != undefined) {
      this.registrationService.deleteRowByMarksId(id).subscribe(data => {
        alert('successfully deleted');
      });
    }
    this.totalMarksTableSize = control.length;
  }

  getStateCity(x, y, z) {
    this.countryId = x;
    this.stateId = y;
    if (x == 1) {
      this.otherOption = false;
    } else {
      this.otherOption = true;
    }
    this.registrationService.getStateCity(x, y, z).subscribe(data => {
      this.stateList = [];
      this.cityList = [];
      this.dataList = data;
      this.stateList = this.dataList.stateList;
      this.cityList = this.dataList.cityList;
    });
  }
  enableOtherInst() {
    const lastschoolName = this.academicForm.get('lastschoolName');
    // console.log(lastschoolName);
    if (this.academicForm.value.lastschoolId == '-1') {
      this.isOtherInst = false;
      lastschoolName.setValidators([Validators.required]);
    } else {
      this.academicForm.controls.lastschoolName.setValue(null);
      this.isOtherInst = true;
      lastschoolName.clearValidators();
    }
    lastschoolName.updateValueAndValidity();
  }

  enableOtherState() {
    const otherSchoolState = this.academicForm.get('otherSchoolState');
    if (this.academicForm.value.stateId == '-1') {
      this.isOtherState = false;
      otherSchoolState.setValidators([Validators.required]);
    } else {
      this.academicForm.controls.otherSchoolState.setValue(null);
      this.isOtherState = true;
      otherSchoolState.clearValidators();
    }
    otherSchoolState.updateValueAndValidity();
  }

  enableOtherCity() {
    const otherSchoolCity = this.academicForm.get('otherSchoolCity');
    if (this.academicForm.value.schoolcityId == '-1') {
      this.isOtherCity = false;
      otherSchoolCity.setValidators([Validators.required]);
    } else {
      this.academicForm.controls.otherSchoolCity.setValue(null);
      this.isOtherCity = true;
      otherSchoolCity.clearValidators();
    }
    otherSchoolCity.updateValueAndValidity();
  }

  onlyregisteredClick(event) {
    if (event.target.value === "Yes") {
      // console.log(event.target.value)
      this.preRegBox = true;

      this.enableCuRegCoursTypPrevClg();
    }
    else {
      this.enableCuRegCoursTypPrevClg();
    }
  }

  enableCuRegCoursTypPrevClg() {
    const prevregno = this.academicForm.get('prevregno');
    const prevcrshdrid = this.academicForm.get('prevcrshdrid');
    const previnstid = this.academicForm.get('previnstid');
    const prevcrshdrother = this.academicForm.get('prevcrshdrother');
    const previnstother = this.academicForm.get('previnstother');
    // const prevuniexam = this.academicForm.get('prevuniexam');
    // console.log(this.academicForm.value.prevadmitted)
    // console.log(prevregno, prevcrshdrid, previnstid)
    // this.preRegBox = false;

    if (this.academicForm.value.prevadmitted == 'Yes') {
      // this.preRegBox = true;
      this.isCuRegCourseTypePrevColg = false;
      prevregno.enable();
      // this.academicForm.get('prevregno').enable();
      // this.academicForm.get('prevcrshdrid').enable();
      // this.academicForm.get('previnstid').enable();
      prevregno.setValidators([Validators.required,Validators.pattern('[0-9-]{16}')]);
      prevcrshdrid.setValidators([Validators.required]);
      previnstid.setValidators([Validators.required]);
      // prevuniexam.setValidators([Validators.required]);
    } else {
      this.isCuRegCourseTypePrevColg = true;
      this.academicForm.controls.prevregno.setValue(null);
      this.academicForm.controls.prevcrshdrid.setValue(null);
      this.academicForm.controls.previnstid.setValue(null);
      this.academicForm.controls.prevcrshdrother.setValue(null);
      this.academicForm.controls.previnstother.setValue(null);
      // this.academicForm.controls.prevuniexam.setValue(null);
      prevregno.disable();
      prevregno.clearValidators();
      prevcrshdrid.clearValidators();
      previnstid.clearValidators();
      prevcrshdrother.clearValidators();
      previnstother.clearValidators();
      // prevuniexam.clearValidators();
    }
    prevregno.updateValueAndValidity();
    prevcrshdrid.updateValueAndValidity();
    previnstid.updateValueAndValidity();
    prevcrshdrother.updateValueAndValidity();
    previnstother.updateValueAndValidity();
    // prevuniexam.updateValueAndValidity();
  }

  showInstDetailsDialog() {
    if (this.academicForm.value.boardResultStatus != 'Pass' && this.failComSelect == false) {
      // this.disablePassInst = true;
      return false;
    }
    if (this.academicForm.value.boardId == null) {
      this.spinner.hide();
      this.alertMsg = [];
      this.alertMsg.push({ severity: 'error', summary: 'Error Message', detail: 'Please select Board' });
      return false;
    }

    //==================================== Append new ===================================================

    if (this.academicForm.value.boardId == 3) {
      this.boardid = 3;
      this.labelName = "Board Roll";
      const regno = this.academicForm.get('regno');
      const registrationno = this.academicForm.get('registrationno');
      registrationno.setValidators([Validators.required,Validators.pattern('[0-9]{10}')]);
      registrationno.updateValueAndValidity();
      regno.setValidators([Validators.pattern('^[0-9]*$')]);

      // console.log(this.academicForm.value.boardId);
    }
    else if (this.academicForm.value.boardId == 2) {
      this.boardid = 2;
      this.labelName = "UID";

      const indexno1 = this.academicForm.get('indexno1');
      const indexno2 = this.academicForm.get('indexno2');
      const regno = this.academicForm.get('regno');
      indexno1.setValidators([Validators.required, Validators.pattern('[0-9]{7}')]);
      indexno2.setValidators([Validators.required, Validators.pattern('[0-9]{3}')]);
      regno.setValidators([Validators.pattern('^[0-9]*$')]);
      indexno1.updateValueAndValidity();
      indexno2.updateValueAndValidity();

      // console.log(this.academicForm.value.boardId);
    }
    else if (this.academicForm.value.boardId == 10) {
      this.boardid = 10;
      this.labelName = "Roll No";

      const schoolno = this.academicForm.get('schoolno');
      const centerno = this.academicForm.get('centerno');
      const admintcardid = this.academicForm.get('admintcardid');
      const regno = this.academicForm.get('regno');
      schoolno.setValidators([Validators.required,Validators.pattern('[0-9]{5}')]);
      // Validators.maxLength(5), Validators.minLength(5), 
      // centerno.setValidators([Validators.required, Validators.maxLength(4), Validators.minLength(4),  Validators.pattern(this.onlyNumeric)]);
      // admintcardid.setValidators([Validators.required, Validators.maxLength(10), Validators.minLength(10),  Validators.pattern(this.alphaNumeric)]);
      // schoolno.setValidators([Validators.pattern(this.onlyNumeric)]);
      centerno.setValidators([Validators.pattern('^[0-9]*$')]);
      // centerno.setValidators([Validators.pattern(this.onlyNumeric)]);
      admintcardid.setValidators([Validators.pattern('^[0-9A-Za-z]*$')]);
      // admintcardid.setValidators([Validators.pattern(this.alphaNumeric)]);
      regno.setValidators([Validators.pattern('^[0-9]*$')])
      schoolno.updateValueAndValidity();
      centerno.updateValueAndValidity();
      admintcardid.updateValueAndValidity();

      // console.log(this.academicForm.value.boardId);

    }
    else {
      this.boarrollnoforotherboard = true;
      this.labelName = "Board Roll No";

      const regno = this.academicForm.get('regno');
      // const boardroll2 = this.academicForm.get('boardroll2');
      regno.enable();
      regno.setValidators([Validators.required]);
      regno.updateValueAndValidity();
      // admintcardid.clearValidators();
      // boardroll2.setValidators([Validators.required, Validators.minLength(1)]);
      // boardroll2.updateValueAndValidity();

      // console.log(this.academicForm.value.boardId);
    }
    // ======================================Append new==================================================
    this.instDetailsDialogDisplay = true;
  }


  doneInstituteDetails() {
    this.mandatoryfieldMsg = [];
    if (this.academicForm.valid) {
      this.instDetailsDialogDisplay = false;
      // console.log(this.academicForm);
    } else {
      // let invalid = <FormControl[]>Object.keys(this.academicForm.controls).map(key => this.academicForm.controls[key]).filter(ctl => ctl.invalid);
      // if (invalid.length > 0) {
      // 	let invalidElem: any = invalid[0];
      // 	invalidElem.nativeElement.focus();
      // 	Object.keys(this.academicForm.controls).forEach(control => {
      // 		this.academicForm.controls[control].markAsDirty();
      // 	});
      // 	return false;
      // }
      // console.log(this.academicForm);
      // this.mandatoryfieldMsg = [];
      // this.mandatoryfieldMsg.push({ severity: 'error', summary: 'All mandatory fields are required.' });
      console.log("not valid")

      this.alertMsg = [];
      this.alertMsg.push({ severity: 'error', summary: 'Error Message', detail: 'All mandatory fields are required.' });

      Object.keys(this.academicForm.controls).forEach(control => {
        this.academicForm.controls[control].markAsDirty();
      });
    }
  }

  enablePrevuniv() {
    const prevadmitted = this.academicForm.get('prevadmitted');
    const prevregno = this.academicForm.get('prevregno');
    // console.log(this.academicForm.value.yearofPassing)

    if (this.academicForm.value.yearofPassing == 2026 || this.academicForm.value.yearofPassing == null) {
      this.isPrevUnivSingle = true;
      // this.isPrevUniv = true;
      prevregno.disable();
      prevregno.clearValidators();

      this.academicForm.controls.prevadmitted.setValue('No');
      this.enableCuRegCoursTypPrevClg();
      prevadmitted.clearValidators();
    } else {
      // this.preRegBox = false;
      // prevadmitted.setValidators([Validators.required]);
      // this.academicForm.controls.prevadmitted.setValue(this.academicForm.value.prevadmitted);
      this.isPrevUnivSingle = false;
      // this.isPrevUniv = true;

      prevregno.enable();
      prevregno.setValidators([Validators.required,Validators.pattern('[0-9-]{16}')]);
      this.enableCuRegCoursTypPrevClg();

    }
    prevadmitted.updateValueAndValidity();
  }



  saveAcademicdetails() {
    const control = this.academicForm.value.subjectDetailInfo;
    // console.log(this.academicForm.value.subjectDetailInfo);
    if (this.paperType === 'Theory Practical') {
      for (let i = 0; i < control.length; i++) {
        if (control[i].paperName == 0) {
          this.msgserror = [];
          this.msgserror.push({
            severity: 'error',
            // summary: 'Please select the red-colored cross beside the empty row no' + (i + 1) + ' to remove them before proceeding.'
            //summary: 'Please select subject at row no.' + (1 + i)
            summary: 'Please complete Marks Entry.'
          });
          return false;
        }
        if (control[i].theoryFullMarks > 0 && control[i].theoryMarksobtained == '') {
          this.msgserror = [];
          this.msgserror.push({
            severity: 'error',
            summary: 'Please enter Theory Marks Obtained at row no.' + (1 + i)
          });
          return false;
        }
        if (control[i].practicalFullMarks > 0 && control[i].practicalMarksobtained == '') {
          this.msgserror = [];
          this.msgserror.push({
            severity: 'error',
            summary: 'Please enter Practical Marks Obtained at row no.' + (1 + i)
          });
          return false;
        }
        if (control[i].status == 0) {
          this.msgserror = [];
          this.msgserror.push({
            severity: 'error',
            summary: 'Please select status at row no.' + (1 + i)
          });
          return false;
        }
        // if (control[i].practicalFullMarks == 0 && control[i].practicalMarksobtained == '') {
        // 	this.msgserror = [];
        // 	this.msgserror.push({
        // 		severity: 'error',
        // 		summary: 'Please enter Practical Marks Obtained at row no.' + (1 + i)
        // 	});
        // 	return false;
        // }
        if (Number(control[i].practicalMarksobtained) > Number(control[i].practicalFullMarks)) {
          this.msgserror = [];
          this.msgserror.push({
            severity: 'error',
            summary: 'Please enter Valid Practical Marks Obtained at row no.' + (1 + i)
          });
          return false;
        }

        if (Number(control[i].theoryMarksobtained) > Number(control[i].theoryFullMarks)) {
          this.msgserror = [];
          this.msgserror.push({
            severity: 'error',
            summary: 'Please enter Valid Theory Marks Obtained at row no.' + (1 + i)
          });
          return false;
        }
      }
    }
    if (this.paperType === 'Grade Level') {
      for (let i = 0; i < control.length; i++) {
        if (control[i].paperName == 0) {
          this.msgserror = [];
          this.msgserror.push({
            severity: 'error',
            summary: 'Please select subject at row no.' + (1 + i)
          });
          return false;
        }

        if (control[i].gradeid == 0) {
          this.msgserror = [];
          this.msgserror.push({
            severity: 'error',
            summary: 'Please select Grade at row no.' + (1 + i)
          });
          return false;
        }
        if (control[i].status == 0) {
          this.msgserror = [];
          this.msgserror.push({
            severity: 'error',
            summary: 'Please select status at row no.' + (1 + i)
          });
          return false;
        }
      }

    }
    if (this.academicForm.valid) {
      let token = localStorage.getItem('authToken');
      const control = this.academicForm.value.subjectDetailInfo;
      if (control.length < 4) {
        this.alertMsg.push({
          severity: 'error',
          summary: 'Please click on Marks Entry button and enter all the subject marks as per Class XII Board Marksheet'
        });
        return false;
      }
      if (control.length == 4) {
        for (let i = 0; i < control.length; i++) {
          if (control[i].paperName == 0) {
            this.alertMsg.push({
              severity: 'error',
              summary:
                'Please select subject at row no.' +
                (1 + i) +
                ' in Marks Details'
            });
            return false;
          }
        }
      }
      // if (this.academicForm.value.regno == null) {
      //   this.alertMsg.push({
      //     severity: 'error',
      //     summary: 'Please complete Institute Details'
      //   });
      //   return false;
      // }
      this.spinner.show();
      this.academicForm.get('boardResultStatus').enable();
      this.academicForm.value.degreeId = 2;
      this.data = {
        academicDetailInfo: [this.academicForm.value]
      };
      // console.log(this.data)
      this.registrationService.saveAcademicDetails(token, this.data).subscribe(data => {
        this.spinner.hide();
        this.resdata = data;
        // console.log(this.resdata.status)
        if (this.resdata.status == 'success') {
          alert('Academic data saved.');
          if (localStorage.getItem('step') !== '') {
            this.router.navigate(['admission/course-information']);
          } else {
            this.router.navigate(['admission/course-information']);
          }
        }
        else {
          alert("not valid");
        }
      }, error => {
        alert('Something went wrong. Please try again')
        this.spinner.hide();
      });
    } else {
      const control = this.academicForm.value.subjectDetailInfo;
      if (this.academicForm.value.boardResultStatus == 'Pass') {
        if (control.length < 4) {
          // this.alertMsg.push({
          //   severity: 'error',
          //   summary: 'Please complete Subjectwise Marks'
          // });
          alert('Please complete Subjectwise Marks');
          return false;
        }
        // if (this.academicForm.value.regno == null) {
        //   // this.alertMsg.push({
        //   //   severity: 'error',
        //   //   summary: 'Please complete Institute Details'
        //   // });
        //   alert('Please complete Institute Details');
        //   return false;
        // }
        alert("Please complete Institute Details")
      }
      else {
        alert('Applicants having Board Result Status as Fail / Compartmental are not eligible for Application / Admission.');
        return false;
      }
      // this.mandatoryfieldMsg = [];
      // this.mandatoryfieldMsg.push({ severity: 'error', summary: 'All mandatory fields are required.' });
      this.alertMsg = [];
      this.alertMsg.push({ severity: 'error', summary: 'Error Message', detail: 'All mandatory fields are required.' });
      // if (this.academicForm.value.boardResultStatus == null)
      //   alert("Please complete Institute Details")
      //console.log('Form Not Submitted!');
      //console.log(this.academicForm);
      Object.keys(this.academicForm.controls).forEach(control => {
        this.academicForm.controls[control].markAsDirty();
      });
    }
  }
  autoLogin() {
    this.registrationService
      .loginByToken(localStorage.getItem('authToken'))
      .subscribe(
        data => {
          // console.log(this.dataList);
          this.dataList = data;
          this.crsselct = this.dataList.courseSelection;
          localStorage.setItem('authToken', this.dataList.authToken);
          localStorage.setItem(
            'userDetails',
            JSON.stringify(this.dataList.userDetails)
          );
          localStorage.setItem('step', this.dataList.step);
          this.patchForm();
        },
        err => console.log(err),
        () => console.log('Request Completed')
      );
  }
  checkRegNo() {
    if (localStorage.getItem("admin") != 'yes') {
      if (this.academicForm.controls.regno.dirty) {
        this.registrationService.checkregNumber(this.academicForm.value.regno).subscribe(data => {
          this.dataList = data;
          if (this.dataList.status == "success") {
            this.alertMsg.push({ severity: 'error', summary: 'Error Message', detail: "Board Roll No Already Exists." });
            this.academicForm.controls.regno.setValue(null);
          }
        }, err => {
          ///alert("Something went wrong, Please try again.")
          this.spinner.hide();
        })
      }
    }

  }

  closemarksEntry() {
    this.mandatoryfieldMsg = [];
    this.marksEntryDialogDisplay = false;
  }

  closeInstDtls() {
    this.mandatoryfieldMsg = [];
    this.instDetailsDialogDisplay = false;
  }

  getPaperList(e) {
    this.spinner.show();
    this.disablePassInst = false;
    const arr = <FormArray>this.academicForm.controls['subjectDetailInfo'];
    arr.controls = [];
    let id = e.target.value;
    let token = localStorage.getItem('authToken');
    this.theoryFullMarks = '';
    this.practicalFullMarks = '';
    this.theoryPassMarks = '';
    this.practicalPassMarks = '';
    if (id > 0) {
      this.registrationService.getPaperList(token, id).then(res => {
        this.spinner.hide();
        // console.log(res);
        this.englishSubjects = res.EngList;
        this.nonEnglishSubjects = res.allpaperlist;
        this.paperType = res.EngList[0].paperName.split("~!~")[1];

        this.englishSubjectsHidden = res.EngList;
        this.nonEnglishSubjectsHidden = res.allpaperlist;
        // this.theoryFullMarks = this.englishSubjects[0].paperName.split("~!~")[2];
        // this.practicalFullMarks = this.englishSubjects[0].paperName.split("~!~")[4];
        // this.theoryPassMarks = this.englishSubjects[0].paperName.split("~!~")[3];
        // this.practicalPassMarks = this.englishSubjects[0].paperName.split("~!~")[5];
      }, err => {
        ///alert("Something went wrong, Please try again.")
        this.spinner.hide();
      })
    }
  }
  calculateMarks(index) {
    const controlArray = <FormArray>this.academicForm.get('subjectDetailInfo');
    let marksdata = [];
    marksdata = this.academicForm.value.subjectDetailInfo;
    let pracmark = marksdata[index].practicalMarksobtained;
    let theroymark = Number(marksdata[index].theoryMarksobtained);
    if (pracmark == undefined) {
      pracmark = 0;
    }
    controlArray.controls[index].get('obtainmarks').setValue(theroymark + Number(pracmark));
  }

  getengpassmarks(index) {
    const control = this.academicForm.value.subjectDetailInfo;
    const controlArray = <FormArray>this.academicForm.get('subjectDetailInfo');
    controlArray.controls[index].get('theoryFullMarks').setValue('');
    controlArray.controls[index].get('practicalFullMarks').setValue('');
    controlArray.controls[index].get('theoryPassMarks').setValue('');
    controlArray.controls[index].get('practicalPassMarks').setValue('');
    controlArray.controls[index].get('fullMarks').setValue('');
    controlArray.controls[index].get('theoryMarksobtained').setValue('');
    controlArray.controls[index].get('practicalMarksobtained').setValue('');
    controlArray.controls[index].get('obtainmarks').setValue('');
    controlArray.controls[index].get('status').setValue('0');
    for (let i = 0; i < this.englishSubjectsHidden.length; i++) {
      control[index].practicalFullMarks = 0;
      if (control[index].paperName == this.englishSubjectsHidden[i].id) {
        controlArray.controls[index].get('theoryFullMarks').setValue(this.englishSubjectsHidden[i].paperName.split("~!~")[2]);
        controlArray.controls[index].get('practicalFullMarks').setValue(this.englishSubjectsHidden[i].paperName.split("~!~")[4]);
        controlArray.controls[index].get('theoryPassMarks').setValue(this.englishSubjectsHidden[i].paperName.split("~!~")[3]);
        controlArray.controls[index].get('practicalPassMarks').setValue(this.englishSubjectsHidden[i].paperName.split("~!~")[5]);
        controlArray.controls[index].get('fullMarks').setValue(Number(this.englishSubjectsHidden[i].paperName.split("~!~")[2]) + Number(this.englishSubjectsHidden[i].paperName.split("~!~")[4]));
        if (this.englishSubjectsHidden[i].paperName.split("~!~")[4] == 0) {
          controlArray.controls[index].get('practicalMarksobtained').disable();
        }
        else {
          controlArray.controls[index].get('practicalMarksobtained').enable();
        }
        break;
      }
    }
  }

  getallsubpassmarks(index) {
    const control = this.academicForm.value.subjectDetailInfo;
    const controlArray = <FormArray>this.academicForm.get('subjectDetailInfo');
    controlArray.controls[index].get('theoryFullMarks').setValue('');
    controlArray.controls[index].get('practicalFullMarks').setValue('');
    controlArray.controls[index].get('theoryPassMarks').setValue('');
    controlArray.controls[index].get('practicalPassMarks').setValue('');
    controlArray.controls[index].get('fullMarks').setValue('');
    controlArray.controls[index].get('theoryMarksobtained').setValue('');
    controlArray.controls[index].get('practicalMarksobtained').setValue('');
    controlArray.controls[index].get('obtainmarks').setValue('');
    controlArray.controls[index].get('status').setValue('0');
    for (let i = 0; i < this.nonEnglishSubjectsHidden.length; i++) {
      if (control[index].paperName == this.nonEnglishSubjectsHidden[i].id) {
        controlArray.controls[index].get('theoryFullMarks').setValue(this.nonEnglishSubjectsHidden[i].paperName.split("~!~")[2]);
        controlArray.controls[index].get('practicalFullMarks').setValue(this.nonEnglishSubjectsHidden[i].paperName.split("~!~")[4]);
        controlArray.controls[index].get('theoryPassMarks').setValue(this.nonEnglishSubjectsHidden[i].paperName.split("~!~")[3]);
        controlArray.controls[index].get('practicalPassMarks').setValue(this.nonEnglishSubjectsHidden[i].paperName.split("~!~")[5]);
        controlArray.controls[index].get('fullMarks').setValue(Number(this.nonEnglishSubjectsHidden[i].paperName.split("~!~")[2]) + Number(this.nonEnglishSubjectsHidden[i].paperName.split("~!~")[4]));
        if (this.nonEnglishSubjectsHidden[i].paperName.split("~!~")[4] == 0) {
          controlArray.controls[index].get('practicalMarksobtained').disable();
        }
        else {
          controlArray.controls[index].get('practicalMarksobtained').enable();
        }
        break;
      }
    }

  }

  enableMarksInstEntry(e) {
    let evntvalue = e.target.value;
    if (e.target.value == 'Pass') {
      this.disablePassInst = false;
    }
    else {
      this.disablePassInst = true;
      alert("Applicants having Board Result Status as Fail / Compartmental are not eligible for Application / Admission.");
      if (this.crsselct == 'no') {
        this.spinner.show();
        this.registrationService.clearAccademicDetail().then(res => {
          this.spinner.hide();
          //console.log('clearmarks', res);
          this.academicForm.reset();
          this.academicForm.get('boardResultStatus').setValue(evntvalue);
        }, err => {
          alert("Something went wrong, Please try again.")
          this.spinner.hide();
        })
      }
    }
  }

  //avoidSpace on board roll no
  avoidSpace(event) {
    let k = event.keyCode;
    if (k == 32) return false;
  }

  goToDashboard() {
    this.router.navigate(['candidate/dashboard']);
  }

  onFloatClick() {
    //window.open("https://app.botbaba.io/bot/1158ALGR6Xj/BESC%20QBOT");
  }

  partOrCbseSelection() {
    const val = this.academicForm.controls['prevuniexam'].value;
    // console.log(val);
    if (val === 'Part-system') {
      this.doneButton = false;
      alert('As per Calcutta University regulations, you are not eligible to apply for any courses. Please read the Eligibility Criteria available on the College website for same.')
      this.router.navigate(['admission/academic-information']);
    } else {
      this.doneButton = true;
    }
  }

  // jd
  preRegistered() {
    this.preRegBox = false;
    this.academicForm.controls.prevadmitted.setValue("Yes");

    // this.enableCuRegCoursTypPrevClg();
  }

  cancelBtn() {
    this.preRegBox = false;
    this.academicForm.controls.prevadmitted.setValue("No");

    this.enableCuRegCoursTypPrevClg();

  }

  // avoidText(event) {
  //   console.log(event.keyCode)
  //   if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode == 45)) {
  //     // console.log(event.keyCode)
  //   } else {
  //     return false;
  //   }
  // }

  avoidText(event): boolean {
      const charCode = (event.which) ? event.which : event.keyCode;
      if (charCode !=45 && (charCode < 48 || charCode > 57)) {
        return false;
      }
      return true;
  }

  enableOtherCourse() {
    // console.log(this.academicForm.controls['prevcrshdrid'].value);
    const prevcrshdrother = this.academicForm.get('prevcrshdrother');
    // console.log(prevcrshdrother);
    if (this.academicForm.value.prevcrshdrid == '-1') {
      prevcrshdrother.enable();
      this.isOtherCourse = false;
      prevcrshdrother.setValidators([Validators.required]);
    } else {
      this.academicForm.controls.prevcrshdrother.setValue(null);
      prevcrshdrother.disable();
      this.isOtherCourse = true;
      prevcrshdrother.clearValidators();
    }
    prevcrshdrother.updateValueAndValidity();
  }

  enableOtherPrevCollege() {
    const previnstother = this.academicForm.get('previnstother');
    // this.academicForm.get('previnstother');
    // console.log(previnstother);
    // console.log(this.academicForm.get('previnstid').value);
    if (this.academicForm.get('previnstid').value == '-1') {
      previnstother.enable();
      this.isOtherPrevCollege = false;
      previnstother.setValidators([Validators.required]);
    }
    else {
      this.academicForm.controls.previnstother.setValue(null);
      previnstother.disable();
      this.isOtherPrevCollege = true;
      previnstother.clearValidators();
    }
    previnstother.updateValueAndValidity();
  }


}




// WEBPACK FOOTER //
// ./src/app/admission/academic-information/academic-information.component.ts